import { useEffect } from 'react';

export const useCtrlASelect = (elementId: string) => {
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.ctrlKey && e.key === 'a') {
                const activeElement = document.activeElement;
                if (activeElement instanceof HTMLInputElement || activeElement instanceof HTMLTextAreaElement) {
                    e.preventDefault();
                    e.stopPropagation();
                    activeElement.select();
                }
            }
        };

        const element = document.getElementById(elementId);
        if (element) {
            element.addEventListener('keydown', handleKeyDown, true);
        }

        return () => {
            if (element) {
                element.removeEventListener('keydown', handleKeyDown, true);
            }
        };
    }, [elementId]);
}
